<template>
    <div>
        <div class="dashboard-detail">
            <carousel                 
                :responsive="carouselConfig.responsivedetail"
                :lazyLoad="true"
                :nav="false"
                :rewind="false"
                :loop="true"
                :autoplay="true"
                :center="true"
                >
                <div 
                    v-for="(image, k) in campaignImage" :key="k">
                    <img :src="image.fullImageUrl" class="img-detail" />
                </div>
            </carousel>
        </div>
</div>
</template>

<script>
import Carousel from "vue-owl-carousel";

export default {
    name: "Picture",
    components: {
        Carousel
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        imgClass: String,
        campaignImage: Array
    },
    data: function() {
        return {
            imgCampaignClass: '',
            carouselConfig: {
                responsivedetail: {
                0: { items: 1 }
                }
            }
        };
    },
    created: function () {
        this.imgCampaignClass = this.imgClass || 'default';
    }
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">
    @import "@/style/base/baseImage.scss";
    @import "@/style/custom/owl.scss";
    .detail-img {
        width: 100%;

        &.default {
            @include baseRatioImg(66.67%);
        }
    }

    #detail_carousel {
        @include owl(rgba(255, 255, 255, 0.5), blue);
    }

    .img-detail {
        border-radius: 10px;
        width: 100%;
        height: 200px;
        object-fit: cover;
    }
    .owl-theme .owl-dots .owl-dot.active span {
        background: #fff;
    }
    .owl-theme .owl-dots .owl-dot span {
        width: 8px;
        height: 8px;
        margin: 5px 2px;
        background: #d6d6d691;
    }
    .owl-theme .owl-nav.disabled + .owl-dots {
        margin-top: 10px;
    }
.dashboard-detail {
    .owl-carousel.owl-drag .owl-item {
        padding: 0 6px;
    }
}
</style>